module.exports = __webpack_public_path__ + "img/shield-minus.3c405efd.svg";